/** Codes match `business_unit.code` from the API / DB seed. */
export const BUSINESS_UNIT_CODE = {
  SOUTHERN_MINT: 'southern_mint',
  TOMS_VENDING: 'toms_vending',
  INVENTORY_AUDITOR: 'inventory_auditor',
} as const;

export function getCurrentBusinessUnitCode(user: unknown): string {
  const u = user as { currentBusinessUnit?: { code?: string } } | null | undefined;
  return u?.currentBusinessUnit?.code ?? BUSINESS_UNIT_CODE.SOUTHERN_MINT;
}

export function isSouthernMintContext(user: unknown): boolean {
  return getCurrentBusinessUnitCode(user) === BUSINESS_UNIT_CODE.SOUTHERN_MINT;
}

export function isTomsVendingContext(user: unknown): boolean {
  return getCurrentBusinessUnitCode(user) === BUSINESS_UNIT_CODE.TOMS_VENDING;
}

export function isInventoryAuditorContext(user: unknown): boolean {
  return getCurrentBusinessUnitCode(user) === BUSINESS_UNIT_CODE.INVENTORY_AUDITOR;
}
